export default "__VITE_ASSET__BxDbclSW__"